module.exports = __webpack_public_path__ + "img/keji.cb80da06.png";